var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"container d-flex jc-center m-y-6"},[_c('spinner',{attrs:{"size":"100px"}})],1):_c('div',[_c('client-only',[(_vm.isPro)?_c('pro-account'):_c('consumer-account')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }